<template>
  <div class="w-full bg-black text-white">
    <!-- Hero com imagem de fundo + fade -->
    <section
      class="relative h-[80vh] bg-cover bg-center"
      :class="[`bg-[url(${banner})]`]"
    >
      <!-- Overlay escuro com gradiente -->
      <div
        class="absolute inset-0 bg-gradient-to-t from-black via-black/80 to-transparent"
      ></div>

      <div
        class="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent flex flex-col justify-end items-start text-white p-8"
      >
        <h1
          class="text-4xl md:text-5xl font-bold mb-2"
        >
          Tudo o que acontece dentro e fora dos rings
        </h1>

        <p class="text-lg md:text-xl">
          Notícias do esporte
        </p>
      </div>
    </section>

    <!-- Container principal -->
    <section class="relative z-10 px-4">
      <div class="max-w-screen-xl mx-auto">

        <!-- Últimas Notícias -->
        <div class="px-6 md:px-20 py-7">
          <h2 class="text-xl md:text-2xl font-bold text-white mb-4 text-start tracking-wider uppercase">
            Últimas Notícias
          </h2>

          <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 uppercase" v-if="news?.latest?.length">
            <NewsCard
              v-for="(item, index) in news?.latest"
              :key="index"
              :title="item.title"
              :image="item.banner"
              :category="item.category"
              :channelLogo="logo"
              :publishedAt="item.created_at"
              @click="seeNotice(TheNotice, item.id)"
            />
          </div>

          <div class="w-full py-3" v-else>
            Em breve... novas noticias
          </div>

        </div>

        <!-- Recomendados -->
        <div class="px-6 md:px-20 py-7">
          <h2 class="text-xl md:text-2xl font-bold text-white mb-4 text-start tracking-wider uppercase">
            Recomendados para você
          </h2>

          <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" v-if="news?.recommended?.length">
            <NewsCard
              v-for="(item, index) in news?.recommended"
              :key="index"
              :title="item.title"
              :image="item.banner"
              :category="item.category"
              :channelLogo="logo"
              :publishedAt="item.created_at"
              @click="seeNotice(TheNotice, item.id)"
            />
          </div>

          <div class="w-full py-3" v-else>
            Ainda não há recomendações
          </div>
        </div>

        <!-- Em Alta -->
        <div class="px-6 md:px-20 py-7">
          <h2 class="text-xl md:text-2xl font-bold text-white mb-4 text-start tracking-wider uppercase">
            Em alta agora
          </h2>

          <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" v-if="news?.hot_now?.length">
            <NewsCard
              v-for="(item, index) in news?.hot_now"
              :key="index"
              :title="item.title"
              :image="item.banner"
              :category="item.category"
              :channelLogo="logo"
              :publishedAt="item.created_at"
              @click="seeNotice(TheNotice, item.id)"
            />
          </div>

          <div class="w-full py-3" v-else>
            Em breve
          </div>
        </div>

        <!-- Mais antigos -->
        <div class="px-6 md:px-20 py-7">
          <h2 class="text-xl md:text-2xl font-bold text-white mb-4 text-start tracking-wider uppercase">
            Mais antigos
          </h2>

          <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" v-if="news?.older?.length">
            <NewsCard
              v-for="(item, index) in news?.older"
              :key="index"
              :title="item.title"
              :image="item.banner"
              :category="item.category"
              :channelLogo="logo"
              :publishedAt="item.created_at"
              @click="seeNotice(TheNotice, item.id)"
            />
          </div>

          <div class="w-full py-3" v-else>
            Em breve
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { dataShared } from '@/shared/store'
import NewsCard from '../auth/components/NewsCard.vue'
import TheNotice from './theNotice.vue'
import { markRaw, onMounted, computed } from 'vue'
import { storeApp } from '@/store'
import SharedService from '@/shared/services/shared'

import { showToast as toast } from '@/helpers/UseToasts'
import router from '@/router'
import defaultLogo from '@/assets/logo/logo-rs.png'

// const banner = require('@/assets/image.png')
const uri = process.env.VUE_APP_BASE_API_URL
const banner = computed(() => {
  return dataShared.getters.getLogo || defaultLogo
})

const logo = require('@/assets/logo/logo-rs.png')

const news = computed(() => dataShared.getters.getNotices)

function seeNotice (value, noticeId) {
  dataShared.dispatch('setNoticeActive', noticeId)
  dataShared.dispatch('setComponentActive', markRaw(value))
}

async function getAllNotices () {
  dataShared.dispatch('activeLoading')

  await SharedService.getCollect()
    .then(res => {
      if (res.data.success) { dataShared.dispatch('setAllNotices', res.data) }

      dataShared.dispatch('desactiveLoading')
    }).catch(err => {
      dataShared.dispatch('desactiveLoading')
      if (err.response.data.status === 401) {
        toast(
          'Aviso',
          'Sua sessão expirou, faça login',
          'error'
        )
      }

      router.push('/auth')
    })
}

onMounted(() => {
  getAllNotices()
})

</script>
